import { GetLocationsForFilterActionTypes, GetLocationsForFilterState, GET_LOCATIONS_FOR_FILTER_FAILURE, GET_LOCATIONS_FOR_FILTER_REQUEST, GET_LOCATIONS_FOR_FILTER_SUCCESS } from './types';

const defaultState: GetLocationsForFilterState = {
  isLoading: false,
  errorMessage: ''
};

export default function locationsForFilter(state = defaultState, action: GetLocationsForFilterActionTypes): GetLocationsForFilterState {
  switch (action.type) {
    case GET_LOCATIONS_FOR_FILTER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_LOCATIONS_FOR_FILTER_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ''
      };
    case GET_LOCATIONS_FOR_FILTER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
};